import { RunStateTransition } from "types/generated";
import ExplainRunButton from "components/Run/elements/ExplainRunButton";

import { RunEntryContext } from "../types";
import StoppedEntry from "../entries/StoppedEntry";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createStoppedEntry = (
  { timestamp, username, stateVersion }: RunStateTransition,
  { stackId, runId }: RunEntryContext
) => (
  <StoppedEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    username={username}
  >
    <ExplainRunButton stackId={stackId} runId={runId} />
  </StoppedEntry>
);
